import { subscribe, unsubscribe } from '../message-bus';
import { MB_ANALYTICS_ADAPTER_READY } from '../consts';
export const whenAdapterReady = (callback) => {
    const token = subscribe({
        topic: MB_ANALYTICS_ADAPTER_READY,
        callback: () => {
            callback();
            unsubscribe(token);
        },
    });
};
